import { useState, useRef, useEffect } from "react";
import "./CountryCodeSelect.css";

export const COUNTRIES = [
  { code: "IN", dial: "+91",  flag: "🇮🇳", name: "India" },
  { code: "US", dial: "+1",   flag: "🇺🇸", name: "United States" },
  { code: "GB", dial: "+44",  flag: "🇬🇧", name: "United Kingdom" },
  { code: "AE", dial: "+971", flag: "🇦🇪", name: "UAE" },
  { code: "SG", dial: "+65",  flag: "🇸🇬", name: "Singapore" },
  { code: "AU", dial: "+61",  flag: "🇦🇺", name: "Australia" },
  { code: "CA", dial: "+1",   flag: "🇨🇦", name: "Canada" },
  { code: "DE", dial: "+49",  flag: "🇩🇪", name: "Germany" },
  { code: "FR", dial: "+33",  flag: "🇫🇷", name: "France" },
  { code: "JP", dial: "+81",  flag: "🇯🇵", name: "Japan" },
  { code: "CN", dial: "+86",  flag: "🇨🇳", name: "China" },
  { code: "BR", dial: "+55",  flag: "🇧🇷", name: "Brazil" },
  { code: "MX", dial: "+52",  flag: "🇲🇽", name: "Mexico" },
  { code: "ZA", dial: "+27",  flag: "🇿🇦", name: "South Africa" },
  { code: "NG", dial: "+234", flag: "🇳🇬", name: "Nigeria" },
  { code: "EG", dial: "+20",  flag: "🇪🇬", name: "Egypt" },
  { code: "SA", dial: "+966", flag: "🇸🇦", name: "Saudi Arabia" },
  { code: "PK", dial: "+92",  flag: "🇵🇰", name: "Pakistan" },
  { code: "BD", dial: "+880", flag: "🇧🇩", name: "Bangladesh" },
  { code: "LK", dial: "+94",  flag: "🇱🇰", name: "Sri Lanka" },
  { code: "NP", dial: "+977", flag: "🇳🇵", name: "Nepal" },
  { code: "ID", dial: "+62",  flag: "🇮🇩", name: "Indonesia" },
  { code: "MY", dial: "+60",  flag: "🇲🇾", name: "Malaysia" },
  { code: "PH", dial: "+63",  flag: "🇵🇭", name: "Philippines" },
  { code: "TH", dial: "+66",  flag: "🇹🇭", name: "Thailand" },
  { code: "VN", dial: "+84",  flag: "🇻🇳", name: "Vietnam" },
  { code: "KR", dial: "+82",  flag: "🇰🇷", name: "South Korea" },
  { code: "IT", dial: "+39",  flag: "🇮🇹", name: "Italy" },
  { code: "ES", dial: "+34",  flag: "🇪🇸", name: "Spain" },
  { code: "NL", dial: "+31",  flag: "🇳🇱", name: "Netherlands" },
  { code: "SE", dial: "+46",  flag: "🇸🇪", name: "Sweden" },
  { code: "NO", dial: "+47",  flag: "🇳🇴", name: "Norway" },
  { code: "CH", dial: "+41",  flag: "🇨🇭", name: "Switzerland" },
  { code: "NZ", dial: "+64",  flag: "🇳🇿", name: "New Zealand" },
  { code: "KE", dial: "+254", flag: "🇰🇪", name: "Kenya" },
  { code: "GH", dial: "+233", flag: "🇬🇭", name: "Ghana" },
  { code: "QA", dial: "+974", flag: "🇶🇦", name: "Qatar" },
  { code: "KW", dial: "+965", flag: "🇰🇼", name: "Kuwait" },
  { code: "BH", dial: "+973", flag: "🇧🇭", name: "Bahrain" },
  { code: "OM", dial: "+968", flag: "🇴🇲", name: "Oman" },
];

export function CountryCodeSelect({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const rootRef = useRef(null);
  const searchRef = useRef(null);

  const selected = COUNTRIES?.find((c) => c?.dial === value && c?.code === (value === "+91" ? "IN" : c?.code))
    || COUNTRIES?.find((c) => c?.dial === value)
    || COUNTRIES[0];

  const filtered = COUNTRIES?.filter(
    (c) =>
      c?.name?.toLowerCase().includes(search?.toLowerCase()) ||
      c?.dial?.includes(search)
  );

  // Close on outside click
  useEffect(() => {
    const handler = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setOpen(false);
        setSearch("");
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  // Focus search on open
  useEffect(() => {
    if (open && searchRef.current) searchRef.current.focus();
  }, [open]);

  return (
    <div ref={rootRef} className="ccs-root">
      <button
        type="button"
        className={`ccs-trigger${open ? " open" : ""}`}
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className="ccs-flag">{selected?.flag}</span>
        <span className="ccs-dial">{selected?.dial}</span>
        <svg
          className={`ccs-chevron${open ? " rotated" : ""}`}
          width="12" height="12" viewBox="0 0 12 12" fill="none"
        >
          <path d="M2 4l4 4 4-4" stroke="currentColor" strokeWidth="1.6"
            strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>

      {open && (
        <div className="ccs-dropdown" role="listbox">
          <div className="ccs-search-wrap">
            <svg className="ccs-search-icon" width="14" height="14" viewBox="0 0 14 14" fill="none">
              <circle cx="6" cy="6" r="4.5" stroke="#94a3b8" strokeWidth="1.4"/>
              <path d="M9.5 9.5l2.5 2.5" stroke="#94a3b8" strokeWidth="1.4" strokeLinecap="round"/>
            </svg>
            <input
              ref={searchRef}
              className="ccs-search"
              placeholder="Search country or code…"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <div className="ccs-list">
            {filtered?.length === 0 && (
              <div className="ccs-empty">No countries found</div>
            )}
            {filtered?.map((c) => (
              <button
                key={c?.code}
                type="button"
                role="option"
                aria-selected={c?.dial === value}
                className={`ccs-item${c?.code === selected?.code ? " selected" : ""}`}
                onClick={() => {
                  onChange(c?.dial, c?.code);
                  setOpen(false);
                  setSearch("");
                }}
              >
                <span className="ccs-item-flag">{c?.flag}</span>
                <span className="ccs-item-name">{c?.name}</span>
                <span className="ccs-item-dial">{c?.dial}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
